import { createContext, useContext } from 'react';

/**
 * Whether the module's channel bar — the All / Email / WhatsApp row and the
 * actions beside it — is folded, and how to bring it back.
 *
 * Folded it is GONE, not shrunk: the whole point is the 48px, and a strip left
 * behind to hold the button back would have spent a third of what it saved. So
 * the way back has to live in whatever view is showing, and every view that can
 * be reached folded needs one — the dashboard opens Campaign, Call Logs and
 * Settings folded too, and a tab with no control is an agent with no way out.
 *
 * A context rather than a pair of props because that is four views across three
 * files, and props threaded through each for a control none of them otherwise
 * cares about is how one of them quietly ends up without it.
 */
export interface ChannelBarState {
  folded: boolean;
  show: () => void;
}

export const ChannelBarContext = createContext<ChannelBarState>({
  folded: false,
  show: () => {},
});

export const useChannelBar = () => useContext(ChannelBarContext);
